"use strict";

var _require = require("../formatters"),
  dateString = _require.dateString;
var moment = require("moment-timezone");
var datetimeObjectParse = function datetimeObjectParse(_ref, formatString, timezone) {
  var date = _ref.date,
    hours = _ref.hours,
    minutes = _ref.minutes,
    am_pm = _ref.am_pm;
  var _am_pm = am_pm.toLowerCase();
  var parsedDate = moment.tz(date, formatString, timezone);
  parsedDate.minutes(minutes);
  var isMidnight = Number(hours) === 12 && _am_pm === "am";
  var _hours = 0;
  if (!isMidnight) {
    _hours = _am_pm === "am" ? hours : Number(hours) + 12;
  }
  parsedDate.hours(_hours);
  return parsedDate;
};
module.exports = datetimeObjectParse;